(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/react/set-deposit-limits-form-dropdown.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/react/set-deposit-limits-form-dropdown.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const logger = svs.accountservicesReact.logger;
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  Fragment = _React.Fragment;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridRow = _svs$ui$ReactGrid.GridRow,
  GridCol = _svs$ui$ReactGrid.GridCol;
const formatCurrency = svs.utils.format.Currency;
const DateForLimitUpdate = svs.accountservicesReact.gameLimitDepositsForm.DateForLimitUpdate;
const DepositLimitDropdown = svs.accountservicesReact.gameLimitDepositsForm.DepositLimitDropdown;
const AmountInput = svs.ui.reactFormInputs.AmountInput;
const Button = svs.ui.ReactButton;
const service = svs.accountservicesReact.gameLimitDepositsForm.maxLimitsService;
const initMaxRange = (isUnderTwenty, isTwentyToTwentyFive) => {
  if (svs.core.userSession.hasRole(svs.core.userSession.roles.CUSTOMERSERVICE)) {
    return 1000000;
  }
  if (isUnderTwenty) {
    return 1000;
  }
  if (isTwentyToTwentyFive) {
    return 5000;
  }
  return 10000;
};
const SetDepositLimitsFormDropdown = _ref => {
  let allDepositLimits = _ref.allDepositLimits,
    isUnderTwenty = _ref.isUnderTwenty,
    isTwentyToTwentyFive = _ref.isTwentyToTwentyFive,
    hasNewlyUpdatedDepositLimits = _ref.hasNewlyUpdatedDepositLimits,
    isChangeLimitsForm = _ref.isChangeLimitsForm,
    costOfGame = _ref.costOfGame,
    currentDayDepositBudget = _ref.currentDayDepositBudget,
    currentWeekDepositBudget = _ref.currentWeekDepositBudget,
    currentMonthDepositBudget = _ref.currentMonthDepositBudget,
    dayLimit = _ref.dayLimit,
    futureDayDepositBudget = _ref.futureDayDepositBudget,
    futureMonthDepositBudget = _ref.futureMonthDepositBudget,
    futureWeekDepositBudget = _ref.futureWeekDepositBudget,
    infoMessage = _ref.infoMessage,
    monthLimit = _ref.monthLimit,
    setDayLimit = _ref.setDayLimit,
    onDone = _ref.onDone,
    setMonthLimit = _ref.setMonthLimit,
    setWeekLimit = _ref.setWeekLimit,
    warningMessage = _ref.warningMessage,
    weekLimit = _ref.weekLimit;
  const history = useHistory();
  const _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    fieldLimitErrors = _useState2[0],
    setFieldLimitErrors = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    formValidationErrors = _useState4[0],
    setFormValidationErrors = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isButtonDisabled = _useState6[0],
    setIsButtonDisabled = _useState6[1];
  const _useState7 = useState(initMaxRange(isUnderTwenty, isTwentyToTwentyFive)),
    _useState8 = _slicedToArray(_useState7, 2),
    maxRange = _useState8[0],
    setMaxRange = _useState8[1];
  const _useState9 = useState(parseInt(maxRange, 10)),
    _useState0 = _slicedToArray(_useState9, 2),
    maxValueDay = _useState0[0],
    setMaxValueDay = _useState0[1];
  const _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isNoChanges = _useState10[0],
    setIsNoChanges = _useState10[1];
  const _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    displayInputFieldMonth = _useState12[0],
    setDisplayInputFieldMonth = _useState12[1];
  const _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    displayInputFieldWeek = _useState14[0],
    setDisplayInputFieldWeek = _useState14[1];
  const _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    displayInputFieldDay = _useState16[0],
    setDisplayInputFieldDay = _useState16[1];
  const _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isNotSelectedMonthAmount = _useState18[0],
    setIsNotSelectedMonthAmount = _useState18[1];
  const _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isNotSelectedWeekAmount = _useState20[0],
    setIsNotSelectedWeekAmount = _useState20[1];
  const _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isNotSelectedDayAmount = _useState22[0],
    setIsNotSelectedDayAmount = _useState22[1];
  const minRange = 25;
  useEffect(() => {
    (async () => {
      const _await$service$getGam = await service.getGamblingCareSpendLimitInfoAsync(),
        data = _await$service$getGam.data,
        error = _await$service$getGam.error;
      if (error) {
        logger.warn('Error getting gambling care spend limit info:', error);
        return;
      }
      const maxLimit = data === null || data === void 0 ? void 0 : data.spendLimit;
      if (maxLimit) {
        setMaxRange(parseInt(maxLimit, 10));
      }
    })();
  }, []);

  useEffect(() => {
    const values = [monthLimit, weekLimit, maxRange];
    const filteredValues = values.filter(value => value > minRange);
    setMaxValueDay(Math.min(...filteredValues));
  }, [monthLimit, weekLimit, maxRange, minRange]);


  const isNumeric = str => {
    if (typeof str != 'string') {
      return false;
    }
    return !isNaN(str) && !isNaN(parseFloat(str)); 
  };

  const validateAllAmountFormattings = () => !isNumeric(dayLimit) || !isNumeric(weekLimit) || !isNumeric(monthLimit);

  const parseFloatOrZero = value => parseFloat(value) || 0;
  const validateDropdowns = () => {
    if (!monthLimit) {
      setIsNotSelectedMonthAmount(true);
    }
    if (!weekLimit) {
      setIsNotSelectedWeekAmount(true);
    }
    if (!dayLimit) {
      setIsNotSelectedDayAmount(true);
    }
  };

  const validateAllLimitSizes = () => {
    const newErrorObject = {};
    const dayLimitNumber = parseFloatOrZero(dayLimit);
    const weekLimitNumber = parseFloatOrZero(weekLimit);
    const monthLimitNumber = parseFloatOrZero(monthLimit);
    if (weekLimitNumber > monthLimitNumber) {
      newErrorObject.weekLimit = 'Din veckogräns kan inte vara högre än din månadsgräns.';
    }
    if (dayLimitNumber > weekLimitNumber && dayLimitNumber > monthLimitNumber) {
      newErrorObject.dayLimit = 'Din dagsgräns kan inte vara högre än din månads- och veckogräns.';
    } else {
      if (dayLimitNumber > monthLimitNumber) {
        newErrorObject.dayLimit = 'Din dagsgräns kan inte vara högre än din månadsgräns.';
      }
      if (dayLimitNumber > weekLimitNumber) {
        newErrorObject.dayLimit = 'Din dagsgräns kan inte vara högre än din veckogräns.';
      }
    }
    setFieldLimitErrors(newErrorObject);
    return Boolean(Object.keys(newErrorObject).length);
  };

  const onValidateHandler = (name, isValid, errorMessage) => {
    if (!isValid) {
      const filteredErrors = [...formValidationErrors.filter(err => err.id !== name)];
      setFormValidationErrors([...filteredErrors, {
        id: name,
        error: errorMessage
      }]);
    } else {
      setFormValidationErrors(formValidationErrors.filter(err => err.id !== name));
    }
  };
  const isValidRange = () => parseFloat(dayLimit) >= minRange && parseFloat(dayLimit) <= maxRange && parseFloat(weekLimit) >= minRange && parseFloat(weekLimit) <= maxRange && parseFloat(monthLimit) >= minRange && parseFloat(monthLimit) <= maxRange;
  const onSubmitHandler = async (e, formData) => {
    e.preventDefault();
    const parsedDayLimit = parseInt(dayLimit, 10);
    const parsedWeekLimit = parseInt(weekLimit, 10);
    const parsedMonthLimit = parseInt(monthLimit, 10);
    if (isChangeLimitsForm && (parsedMonthLimit === currentMonthDepositBudget || parsedMonthLimit === futureMonthDepositBudget) && (parsedWeekLimit === currentWeekDepositBudget || parsedWeekLimit === futureWeekDepositBudget) && (parsedDayLimit === currentDayDepositBudget || parsedDayLimit === futureDayDepositBudget)) {
      setIsNoChanges(true);
      return;
    }
    const hasNoChoosenValues = validateDropdowns();
    if (hasNoChoosenValues) {
      return;
    }
    if (formValidationErrors.length) {
      logger.debug('has form validation errors: ', formValidationErrors);
      return;
    }
    const hasFormattingErrors = validateAllAmountFormattings();
    if (hasFormattingErrors) {
      logger.debug('has formatting errors: ', hasFormattingErrors);
      return;
    }
    const hasLimitErrors = validateAllLimitSizes();
    if (hasLimitErrors) {
      logger.debug('has limit errors:', hasLimitErrors);
      return;
    }
    const hasValidRange = isValidRange();
    if (!hasValidRange) {
      return;
    }
    if (isButtonDisabled) {
      return;
    }
    setIsButtonDisabled(true);
    if (isChangeLimitsForm) {
      onDone(e, formData);
    } else {
      onDone(!displayInputFieldMonth, !displayInputFieldWeek, !displayInputFieldDay);
    }
    setIsButtonDisabled(false);
  };
  const errorMessageMin = () => "Den l\xE4gsta gr\xE4nsen du kan s\xE4tta \xE4r ".concat(formatCurrency(minRange), " kr.");
  const errorMessageMax = () => "Du kan inte ha en h\xF6gre gr\xE4ns \xE4n ".concat(formatCurrency(maxRange), " kr.");
  return React.createElement(Form, {
    className: "margin-h-0 align-left",
    onSubmit: onSubmitHandler,
    onValidate: onValidateHandler,
    setError: fieldLimitErrors
  }, React.createElement(ControlGroup, {
    isLessSpace: true,
    v2: true
  }, React.createElement(DepositLimitDropdown, {
    costOfGame: costOfGame,
    errorMessageRequired: "Du m\xE5ste ange m\xE5nadsgr\xE4ns",
    hasErrorRequired: isNotSelectedMonthAmount && !monthLimit && !displayInputFieldMonth,
    maxValue: parseInt(maxRange, 10),
    minValue: parseInt(weekLimit, 10),
    onSelect: chosenValue => {
      if (chosenValue === 'Månadsgräns') {
        return setDisplayInputFieldMonth(false);
      }
      if (chosenValue === 'own-amount') {
        return setDisplayInputFieldMonth(true);
      }
      setMonthLimit(chosenValue.toString());
      setDisplayInputFieldMonth(false);
    },
    period: "M\xE5nadsgr\xE4ns"
  }), displayInputFieldMonth === true && React.createElement(AmountInput, {
    errorMessageDefault: "Ange beloppet med hela siffror.",
    errorMessageMax: errorMessageMax(),
    errorMessageMin: errorMessageMin(),
    errorMessageRequired: "Du m\xE5ste ange m\xE5nadsgr\xE4ns",
    isLessSpace: true,
    label: "M\xE5nadsgr\xE4ns",
    max: maxRange,
    min: minRange,
    name: "monthLimit",
    onChange: e => {
      setMonthLimit(e.target.value);
      setIsNoChanges(false);
    },
    placeholder: "Skriv beloppet i kronor",
    value: monthLimit
  })), React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(DepositLimitDropdown, {
    costOfGame: costOfGame,
    errorMessage: !displayInputFieldWeek ? fieldLimitErrors.weekLimit : undefined,
    errorMessageRequired: "Du m\xE5ste ange veckogr\xE4ns",
    hasErrorRequired: isNotSelectedWeekAmount && !weekLimit && !displayInputFieldWeek,
    id: "week-dropdown",
    maxValue: monthLimit ? parseInt(monthLimit, 10) : parseInt(maxRange, 10),
    minValue: parseInt(dayLimit, 10),
    onSelect: chosenValue => {
      if (chosenValue === 'Veckogräns') {
        return setDisplayInputFieldWeek(false);
      }
      if (chosenValue === 'own-amount') {
        return setDisplayInputFieldWeek(true);
      }
      setWeekLimit(chosenValue.toString());
      setDisplayInputFieldWeek(false);
    },
    period: "Veckogr\xE4ns"
  }), displayInputFieldWeek && React.createElement(AmountInput, {
    errorMessageDefault: "Ange beloppet med hela siffror.",
    errorMessageMax: errorMessageMax(),
    errorMessageMin: errorMessageMin(),
    errorMessageRequired: "Du m\xE5ste ange veckogr\xE4ns",
    isLessSpace: true,
    label: "Veckogr\xE4ns",
    max: maxRange,
    min: minRange,
    name: "weekLimit",
    onChange: e => {
      setWeekLimit(e.target.value);
      setIsNoChanges(false);
    },
    placeholder: "Skriv beloppet i kronor",
    value: weekLimit
  })), React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(DepositLimitDropdown, {
    costOfGame: costOfGame,
    errorMessage: !displayInputFieldDay ? fieldLimitErrors.dayLimit : undefined,
    errorMessageRequired: "Du m\xE5ste ange dagsgr\xE4ns",
    hasErrorRequired: isNotSelectedDayAmount && !dayLimit && !displayInputFieldDay,
    id: "day-dropdown",
    maxValue: maxValueDay,
    onSelect: chosenValue => {
      if (chosenValue === 'Dagsgräns') {
        return setDisplayInputFieldDay(false);
      }
      if (chosenValue === 'own-amount') {
        return setDisplayInputFieldDay(true);
      }
      setDayLimit(chosenValue.toString());
      setDisplayInputFieldDay(false);
    },
    period: "Dagsgr\xE4ns"
  }), displayInputFieldDay && React.createElement(AmountInput, {
    errorMessageDefault: "Ange beloppet med hela siffror.",
    errorMessageMax: errorMessageMax(),
    errorMessageMin: errorMessageMin(),
    errorMessageRequired: "Du m\xE5ste ange dagsgr\xE4ns",
    isLessSpace: true,
    label: "Dagsgr\xE4ns",
    max: maxRange,
    min: minRange,
    name: "dayLimit",
    onChange: e => {
      setDayLimit(e.target.value);
      setIsNoChanges(false);
    },
    placeholder: "Skriv beloppet i kronor",
    value: dayLimit
  })), infoMessage && React.createElement("div", {
    className: "margin-top-2"
  }, infoMessage), warningMessage && React.createElement("div", {
    className: "margin-top-2"
  }, warningMessage), isChangeLimitsForm ? React.createElement(Fragment, null, allDepositLimits && React.createElement(DateForLimitUpdate, {
    allLimits: allDepositLimits,
    hasMarginTop: true,
    isNewlyUpdatedLimits: hasNewlyUpdatedDepositLimits
  }), isNoChanges && React.createElement("p", {
    className: "margin-top-2"
  }, "Det finns inga nya gr\xE4nser att spara."), React.createElement("div", {
    className: "margin-top-2 margin-bottom-1"
  }, React.createElement(GridRow, {
    md: {
      gutter: 1
    },
    xs: {
      gutter: 1
    }
  }, React.createElement(GridCol, {
    md: 6,
    xs: 6
  }, React.createElement(Button, {
    block: true,
    onClick: () => history.push('/'),
    transparent: true,
    type: "button"
  }, "Tillbaka")), React.createElement(GridCol, {
    md: 6,
    xs: 6
  }, React.createElement(Button, {
    block: true,
    id: "depositLimitSubmit",
    inverted: true,
    type: "submit"
  }, "Spara \xE4ndringar"))))) : React.createElement(Button, {
    block: true,
    className: "margin-top-2 margin-bottom-1",
    disabled: isButtonDisabled,
    focus: true,
    type: "submit"
  }, "Forts\xE4tt"));
};
svs.accountservicesReact.gameLimitDepositsForm.SetDepositLimitsFormDropdown = SetDepositLimitsFormDropdown;

 })(window);